// Smooth-scroll helpers. Global `scroll-behavior: smooth` is also set in index.css.
export function scrollToId(id) {
  if (typeof document === 'undefined') return;
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
